import clockOut from '../Services/clockOut'

export default () => (dispatch) => {

  dispatch(clockOut())

}
